<template>
  <section class="ai-visibility-data-table">
    <div v-if="$slots.toolbar" class="ai-visibility-data-table__toolbar">
      <slot name="toolbar"/>
    </div>
    <div class="ai-visibility-data-table__scroll">
      <div class="ai-visibility-data-table__table" :style="{ minWidth }" role="table">
        <div v-if="$slots.head" role="rowgroup">
          <slot name="head"/>
        </div>
        <div v-if="$slots.body" role="rowgroup">
          <slot name="body"/>
        </div>
      </div>
    </div>
    <div v-if="$slots.footer" class="ai-visibility-data-table__footer">
      <slot name="footer"/>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    minWidth: {
      type: String,
      default: '720px',
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-data-table {
  overflow: hidden;
  background: var(--v-cardBg-base);
}

.ai-visibility-data-table__toolbar,
.ai-visibility-data-table__footer {
  padding: 14px 16px;

}

.ai-visibility-data-table__footer {
  position: relative;
  margin-bottom: 14px;

  &::after {
    position: absolute;
    right: 20px;
    bottom: 0;
    left: 20px;
    border-bottom: 1px dashed var(--v-gray12Color-base);
    content: "";
    pointer-events: none;
  }
}

.ai-visibility-data-table__toolbar {
  border-bottom: 1px solid var(--v-gray13Color-base);
}

.ai-visibility-data-table__scroll {
  overflow-x: auto;
}

.ai-visibility-data-table__table {
  width: 100%;
  padding-top: 10px;
}

</style>
